module.exports = __webpack_public_path__ + "c59023ef24dd94cbf4a94097893df952.png";